import { toast } from "react-toastify";
import { getApiBaseUrl } from "../utils/apiBaseUrl";

export interface ApiAccessRequestHistory {
  id: number;
  userId: number;
  userName: string;
  email: string;
  phoneNumber: string;
  status: string;
  requestedAt: string;
  reviewedAt: string | null;
  reviewedBy: number | null;
  reviewerName: string | null;
}

export const getApiAccessRequestHistory = async (
  token: string,
  t: (key: string) => string
): Promise<ApiAccessRequestHistory[]> => {
  if (!token) {
    throw new Error("Token not found");
  }

  try {
    const baseUrl = getApiBaseUrl();

    const response = await fetch(
      `${baseUrl}/api/Admin/GetApiAccessRequestHistory`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch API access request history");
    }

    const data: ApiAccessRequestHistory[] = await response.json();
    return data;
  } catch (error) {
    toast.error(t("somethingWentWrong"));
    throw error;
  }
};